'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { DeviceAlertListPage } from '../../-components/DeviceAlertListPage';
import { DEVICE_ALERT_CATEGORY } from '../../-constants';
import { DeviceAlertListSearchSchema } from '../../-zod-schema';
export const Route = createFileRoute('/_staff/devices/_list/alerts/_alerts/lease-expiring/')({
  validateSearch: zodValidator(DeviceAlertListSearchSchema),
  component: LeaseExpiringAlertsPage
});
function LeaseExpiringAlertsPage() {
  return <DeviceAlertListPage category={DEVICE_ALERT_CATEGORY.LEASE_EXPIRING} categoryKey="leaseExpiring" />;
}